/**
 * Iconify Icons Registry
 * Provides brand icons (LinkedIn, Slack, Facebook, Twitter) via @iconify/react
 */

import { Icon } from '@iconify/react';
import type { ReactNode } from 'react';

import type {
  IconDefinition,
  IconRenderer,
  IconRenderProps,
} from '@/sections/attacks/attackPaths/components/icons/registry/icon-renderers-map';
import { iconRenderers } from '@/sections/attacks/attackPaths/components/icons/registry/icon-renderers-map';

const iconifyRenderer: IconRenderer = {
  render: (name: string, { size, className }: IconRenderProps): ReactNode => {
    return (
      <Icon icon={name} width={size} height={size} className={className} />
    );
  },

  validate: (_name: string): boolean => {
    return true; // Iconify handles invalid icons gracefully
  },

  getIcon: (name: string) => {
    return function WrappedIconifyIcon({
      size = 24,
      className,
    }: {
      size?: number;
      className?: string;
    }) {
      return (
        <Icon icon={name} width={size} height={size} className={className} />
      );
    };
  },

  getAll: (): IconDefinition[] => [],
};

iconRenderers.set('iconify', iconifyRenderer);

export { iconifyRenderer };
